import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { CourseChoices } from "utils/choices";
import { useFormContext, useWatch } from "react-hook-form";

const SessionExamSchedule = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="academicYearId"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectInput
          label="Учебна година"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("academicYearId", e.target.value)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId: structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            validate={[required()]}
            emptyText={false}
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}

      <ReferenceInput
        source="sessionType"
        reference={studentRequests.getAcademicSessionTypesSelect()}
        filter={{ sessionsOnly: true }}
      >
        <SelectInput
          label="Сесия"
          emptyText={false}
          onChange={e => handleParamChange("sessionType", e.target.value)}
        />
      </ReferenceInput>
      <SelectInput
        source="course"
        label="Курс"
        choices={CourseChoices}
        emptyText={false}
        onChange={e => handleParamChange("course", e.target.value)}
      />
    </>
  );
};

export default SessionExamSchedule;
